"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SetCouponBoxComponent.default;
  }
});

var _SetCouponBoxComponent = _interopRequireDefault(require("./SetCouponBox-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }